import { WithAdditionalMarketoFormOverrideProps } from 'marketing-site/src/components/context/MarketoFormOverridePropsContext'
import {
  IOnMarketoFormSubmit,
  IProps as IMarketoFormV2Props,
} from 'marketing-site/src/library/components/MarketoFormV2'
import { useSessionStorage } from 'marketing-site/src/library/hooks/use-session-storage'
import React, { useEffect } from 'react'
import { IPageBehaviorComponentProps } from './PageBehaviors'
import { localiseURL } from 'marketing-site/src/library/utils/localiseURL'

const SOLUTION = {
  ENGAGE: 'engage',
  SUPPORT: 'support',
  CONVERT: 'convert',
}

const SOLUTION_URL = {
  [SOLUTION.SUPPORT]: '/view-demos/support',
  [SOLUTION.ENGAGE]: '/view-demos/engage',
  [SOLUTION.CONVERT]: '/view-demos/convert',
}

const getSolutionPath = (solution: string | null) =>
  (solution && SOLUTION_URL[solution]) || SOLUTION_URL[SOLUTION.SUPPORT]

export default function ViewDemoDeepLink({
  children,
}: IPageBehaviorComponentProps): React.ReactElement {
  const [companySize, setCompanySize] = useSessionStorage<string | null>('company-size', null)

  const redirectTo = () => {
    const url = new URL(window.location.href)
    const locale = url.pathname.split('/')[1]
    const solution = getSolutionPath(url.searchParams.get('solution'))
    const urlLocalized = localiseURL(solution, !locale.includes('view-demos') ? locale : 'en-US')
    window.location.replace(urlLocalized)
  }

  useEffect(() => {
    companySize && redirectTo()
  }, [])

  const onMarketoFormSubmit: IOnMarketoFormSubmit = (response, submittedValues) => {
    if (response.success && response.result?.type !== 'submit') {
      setCompanySize(submittedValues?.NumberOfEmployees || null)
      redirectTo()
    }
  }

  const marketoOverrideProps: Partial<IMarketoFormV2Props> = {
    onSubmit: onMarketoFormSubmit,
    mergeSubmit: true,
  }

  return (
    <WithAdditionalMarketoFormOverrideProps overrideProps={marketoOverrideProps}>
      {children}
    </WithAdditionalMarketoFormOverrideProps>
  )
}
